import { Dictionary } from "@/types/Dictionary";

const legacyVersionToDisplayVersion: Dictionary<string> = {
  "0.0.27.11": "1.3.25.0", // firmware
  "0.0.75.30": "1.1.0.0", // hardware
  "0.0.27.10": "1.0.0.0", // parameters
};

export function useFormatVersion() {
  const emptyVersion = "0.0.0.0";

  function formatVersion(version: unknown) {
    if (typeof version !== "string") {
      return emptyVersion;
    }
    return version in legacyVersionToDisplayVersion
      ? legacyVersionToDisplayVersion[version]
      : version;
  }

  return { formatVersion, emptyVersion };
}
